<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pb-2 mb-2 globalborder-btm-header px-3"
        [ngClass]="{ 'p-3': !isFromStacker }">
        <span class="col-auto d-flex gap-3 align-items-center">
          <h2 class="mb-0">
            Inventory Purchases

            <b> {{ samplePONumber }}</b>
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
          <!-- <span class="client-badge d-flex align-items-center">
            {{ samplePONumber }}
          </span> -->

          <div class="ms-3 nav-link p-0 d-flex align-items-center">
            <a class="link" (click)="redirectToLinesGroup()"
              ><i class="pi pi-pencil"></i> Lines Group Items</a
            >
          </div>
          <div class="ms-3 nav-link p-0 d-flex align-items-center">
            <!-- <a class="link" (click)="onPreview()">View PDF</a> -->
            <a class="link" (click)="openPrinfPdfModal()"
              >Child PO confirmations</a
            >
          </div>
          <div class="ms-3 nav-link p-0 d-flex align-items-center">
            <a class="link" (click)="copyInventoryPurchase()"
              >Exact Order Copy</a
            >
          </div>
        </span>
        <span class="d-flex gap-2 customizefilter-btn align-items-center">
          <p-button
            (click)="editFields()"
            label="Edit"
            variant="outlined"
            icon="pi pi-pen-to-square"
            severity="secondary" />

          <span class="cross-border" (click)="onCancel()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div
        class="col-12 adduser-container-hgt px-3"
        [ngClass]="{ 'p-3': !isFromStacker }">
        <!-- <div
    class="samplepo-header has-border d-flex pb-2 mb-2 justify-content-between">
    
    <button (click)="editFields()">Edit</button>
    <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div> -->
        <form action="#" [formGroup]="samplePOForm" class="label-fontsize">
          <div class="col-12" formGroupName="header">
            <div class="gray-bg-rounded">
              <div class="d-flex gap-2">
                <div class="col mb-2 vendor-account">
                  <div class="form-group has-float-label">
                    <label class="form-label"
                      >3PL <span class="madatory-field">*</span></label
                    >
                    <input
                      pInputText
                      #mydropInpurt
                      jniAutoCompleteBlocker
                      type="text"
                      id="vendoraccount"
                      name="vendoraccount"
                      class="form-control"
                      [value]="vendorAccountNumber"
                      formControlName="orderVendorAccountNumberD365"
                      (input)="searchVendor$.next($any($event.target).value)"
                      (keyup)="
                        onVendorSearchOpenToggle(
                          ngbDropVendor,
                          $event,
                          mydropInpurt
                        )
                      "
                      [ngClass]="{
                        'has-error': formErrors['vendorAccountNumber'],
                      }"
                      (blur)="logValidationErrors()" />
                    <!-- <label class="form-label">Vendor Account<span class="madatory-field">*</span></label> -->

                    <span
                      class="error-msg"
                      *ngIf="formErrors['vendorAccountNumber']">
                      {{ formErrors["vendorAccountNumber"] }}
                    </span>
                  </div>
                  <p-popover #ngbDropVendor aria-labelledby="dropdownBasic1">
                    <p-table
                      #dt
                      [value]="vendorList"
                      styleClass="p-datatable-customers po-small"
                      [rowHover]="true"
                      [rows]="10"
                      [showCurrentPageReport]="true"
                      [rowsPerPageOptions]="[10, 25, 50]"
                      [paginator]="false"
                      [filterDelay]="0">
                      <ng-template pTemplate="header">
                        <tr>
                          <th class="name">Name</th>
                          <th class="vaccount">3PL</th>
                          <th class="sname">Search name</th>
                          <th class="phone">Phone</th>
                          <th class="city">City</th>
                          <th class="state">State</th>
                          <th class="country">Country</th>
                        </tr>
                      </ng-template>
                      <ng-template
                        pTemplate="body"
                        let-vendorList
                        let-rowIndex="rowIndex">
                        <tr
                          class="p-selectable-row mousepointer"
                          (click)="
                            onVendorRowSelection(vendorList, ngbDropVendor)
                          ">
                          <td class="name mousepointer">
                            {{ vendorList.vendorName }}
                          </td>
                          <td class="vaccount mousepointer">
                            {{ vendorList.vendorAccountNumber }}
                          </td>
                          <td class="sname mousepointer">
                            {{ vendorList.vendorSearchName }}
                          </td>
                          <td class="phone mousepointer">
                            {{ vendorList.phoneNumber }}
                          </td>
                          <td class="city mousepointer">
                            {{ vendorList.city }}
                          </td>
                          <td class="state mousepointer">
                            {{ vendorList.state }}
                          </td>
                          <td class="country mousepointer">
                            {{ vendorList.country }}
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="20">No vendor found.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </p-popover>
                </div>

                <div class="mb-2 col-2 gap-2 d-flex m-0 align-items-top">
                  <div class="form-group has-float-label date-field">
                    <!-- <input pInputText
              jniAutoCompleteBlocker
              id="shipdate"
              name="shipdate"
              class="form-control"
              [min]="shipDateCurrentdate | date: 'yyyy-MM-dd'"
              (change)="onShipDateSelection($event)"
              onfocus="(this.type='date')"
              onblur="if(!this.value) this.type='text'"
            /> -->
                    <label class="form-label">Ship date</label>
                    <p-datePicker
                      jniAutoCompleteBlocker
                      inputId="basic"
                      class="date-input"
                      (onSelect)="onShipDateSelection($event)"
                      formControlName="expectedStoreAvailableSalesDateD365"
                      [minDate]="shipDateCurrentdate"
                      [showOtherMonths]="true"
                      [selectOtherMonths]="true"></p-datePicker>
                  </div>
                  <div class="form-group has-float-label date-field">
                    <!-- <input pInputText
              jniAutoCompleteBlocker
              id="inhandsdate"
              name="inhandsdate"
              class="form-control"
              [min]="inHandDateCurrentdate | date: 'yyyy-MM-dd'"
              (change)="onInHandDateSelection($event)"
              onfocus="(this.type='date')"
              onblur="if(!this.value) this.type='text'"
            /> -->
                    <label class="form-label">In Hands date</label>
                    <p-datePicker
                      jniAutoCompleteBlocker
                      inputId="basic"
                      class="date-input"
                      (onSelect)="onInHandDateSelection($event)"
                      formControlName="expectedStoreReceiptDateD365"
                      [minDate]="inHandDateCurrentdate"
                      [showOtherMonths]="true"
                      [selectOtherMonths]="true"></p-datePicker>

                    <span
                      class="error-msg"
                      *ngIf="formErrors['expectedStoreReceiptDateD365']">
                      {{ formErrors["expectedStoreReceiptDateD365"] }}
                    </span>
                  </div>
                  <!-- <div class="form-check">
          <label class="firm">Firm</label>
          <input pInputText
            type="checkbox"
            class="form-check-input m-0 no-bg"
            formControlName="firm"
            (click)="onFirmChange($event)"
          />
        </div> -->
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Job name</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      placeholder=""
                      formControlName="jobNameD365"
                      [ngClass]="{ 'has-error': formErrors['jobNameD365'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['jobNameD365']">
                      {{ formErrors["jobNameD365"] }}
                    </span>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Customer Ref</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      placeholder=""
                      formControlName="customerRef365"
                      [ngClass]="{ 'has-error': formErrors['customerRef'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['customerRef']">
                      {{ formErrors["customerRef"] }}
                    </span>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Store</label>
                    <p-select
                      id="storeD365"
                      formControlName="storeD365"
                      (onChange)="onOwnerDropDownChange($event)"
                      [filter]="true"
                      [showClear]="true"
                      [options]="filteredStoresField"
                      optionLabel="name"
                      optionValue="name">
                    </p-select>

                    <span class="error-msg" *ngIf="formErrors['storeD365']">
                      {{ formErrors["storeD365"] }}
                    </span>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Owner</label>
                    <p-select
                      id="owner"
                      formControlName="ownerD365"
                      [options]="filtered_owner_list"
                      optionLabel="value"
                      optionValue="value"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>

                    <span class="error-msg" *ngIf="formErrors['ownerD365']">
                      {{ formErrors["ownerD365"] }}
                    </span>
                  </div>
                </div>

                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Site</label>
                    <p-select
                      id="siteD365"
                      formControlName="siteD365"
                      (onChange)="onSelectionChange($event, 'site')"
                      [options]="siteField"
                      optionLabel="name"
                      optionValue="name"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Warehouse</label>
                    <p-select
                      id="warehouseD365"
                      formControlName="warehouseD365"
                      (onChange)="onSelectionChange($event, 'warehouse')"
                      [options]="warehouseField"
                      optionLabel="name"
                      optionValue="name"
                      [filter]="true"
                      [showClear]="true">
                    </p-select>

                    <span class="error-msg" *ngIf="formErrors['warehouseD365']">
                      {{ formErrors["warehouseD365"] }}
                    </span>
                  </div>
                </div>
                <div class="col mb-2 brand-conslt">
                  <div class="form-group has-float-label" id="dropdownBasic4">
                    <label class="form-label"
                      >Branding Consultant<span class="madatory-field"
                        >*</span
                      ></label
                    >
                    <input
                      pInputText
                      #bcdropdownInput
                      jniAutoCompleteBlocker
                      type="text"
                      id="brandingConsultant"
                      name="brandingConsultant"
                      class="form-control"
                      formControlName="brandingConsultantIdD365"
                      (click)="
                        onBrandingConsultantSelection(
                          ngbDropBC,
                          $event,
                          bcdropdownInput
                        )
                      "
                      [ngClass]="{
                        'has-error': formErrors['brandingConsultant'],
                      }"
                      (blur)="logValidationErrors()" />

                    <span
                      class="error-msg"
                      *ngIf="formErrors['brandingConsultantIdD365']">
                      {{ formErrors["brandingConsultantIdD365"] }}
                    </span>
                    <p-popover #ngbDropBC aria-labelledby="dropdownBasic4">
                      <p-table
                        #dt
                        [value]="brandingConsultantLists"
                        styleClass="p-datatable-customers"
                        [rowHover]="true"
                        [rows]="10"
                        [showCurrentPageReport]="true"
                        [rowsPerPageOptions]="[10, 25, 50]"
                        [paginator]="false"
                        [filterDelay]="0">
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="name">Project id</th>
                            <th class="vaccount">Project name</th>
                          </tr>
                        </ng-template>
                        <ng-template
                          pTemplate="body"
                          let-brandingConsultantList
                          let-rowIndex="rowIndex">
                          <tr
                            class="p-selectable-row mousepointer"
                            (click)="
                              onProjectIdSelection(
                                brandingConsultantList,
                                ngbDropBC
                              )
                            ">
                            <td class="name mousepointer">
                              {{ brandingConsultantList.projectId }}
                            </td>
                            <td class="name mousepointer">
                              {{ brandingConsultantList.projectName }}
                            </td>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                          <tr>
                            <td colspan="20">No project found.</td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </p-popover>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Accounts coordinator</label>
                    <p-select
                      formControlName="accountCoordinatorD365"
                      [options]="bacList"
                      optionValue="personnelNumber"
                      [filter]="true"
                      [showClear]="true">
                      <ng-template #selectedItem let-selectedOption>
                        {{ selectedOption.personnelNumber }} :
                        {{ selectedOption.name }}
                      </ng-template>
                      <ng-template let-country #item>
                        {{ country.personnelNumber }} : {{ country.name }}
                      </ng-template>
                    </p-select>
                  </div>
                </div>
                <div class="col mb-2">
                  <div class="form-group has-float-label">
                    <label class="form-label">Mock GP %</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      placeholder=""
                      formControlName="gpPercentage"
                      [ngClass]="{ 'has-error': formErrors['gpPercentage'] }"
                      (blur)="logValidationErrors()" />

                    <span class="error-msg" *ngIf="formErrors['gpPercentage']">
                      {{ formErrors["gpPercentage"] }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <div class="row">
                <div class="col-4">
                  <div class="gray-bg-rounded" formGroupName="header">
                    <h3 class="mb-2">Vendor</h3>
                    <div
                      class="form-group has-float-label mb-2"
                      (click)="onVendorModal()">
                      <label class="form-label">Vendor name</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control has-link"
                        placeholder=""
                        formControlName="vendorName" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Vendor Address</label>
                      <textarea
                        pInputText
                        rows="5"
                        jniAutoCompleteBlocker
                        placeholder=""
                        class="form-control"
                        formControlName="vendorAddress"></textarea>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Phone number</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        placeholder=""
                        formControlName="vendorPhone" />
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Email Address</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="email"
                        class="form-control"
                        placeholder=""
                        formControlName="vendorEmail" />
                    </div>
                  </div>
                </div>

                <div class="col-4">
                  <div class="gray-bg-rounded">
                    <h3 class="mb-2">Ship to</h3>
                    <jni-inventory-purchase-ship-to-address
                      #samplepoaddress
                      [parent]="samplePOForm"
                      [formgroupName]="'addressInformation'"
                      [brandingConsultantObject]="brandingConsultantObject"
                      [customerBillToObject]="customerBillToObject"
                      [deliveryAddress]="deliveryAddress"
                      [cityList]="cityList"
                      [countryRegionList]="countryRegionList"
                      [countyList]="countyList"
                      [districtList]="districtList"
                      [formErrors]="formErrors"
                      [validationMessages]="validationMessages"
                      [addressField]="addressField"
                      (validationErrorEvent)="logValidationErrors()">
                    </jni-inventory-purchase-ship-to-address>
                  </div>
                </div>
                <div class="col-4">
                  <div class="gray-bg-rounded" formGroupName="header">
                    <h3 class="mb-2">Details</h3>
                    <div class="form-group has-float-label mb-2">
                      <div class="form-group has-float-label">
                        <label class="form-label">Shipping Method</label>
                        <p-select
                          id="currency"
                          formControlName="deliveryModeIdD365"
                          (onChange)="onShippingMethodSelect($event)"
                          [filter]="true"
                          [showClear]="true"
                          [options]="shippingProductsList"
                          optionLabel="modeDescriptionD365"
                          optionValue="modeCodeD365">
                        </p-select>
                      </div>
                    </div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Account #</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        placeholder=""
                        formControlName="accountNumber" />
                    </div>
                    <label class="form-label">Net in Foreign Currency</label>
                    <div
                      class="form-group has-float-label mb-2 d-flex align-items-center gap-2">
                      <p-checkBox
                        formControlName="isnetInForeignCurrencyStatus"
                        (onChange)="onCurrencyEnable($event)" />
                      <div class="form-group has-float-label flex-grow-1">
                        <p-select
                          id="currency"
                          formControlName="currencyCodeD365"
                          (onChange)="onCurrencyConversion()"
                          [options]="currencyList"
                          optionLabel="isoCurrencyCodeD365"
                          optionValue="isoCurrencyCodeD365"
                          [filter]="true"
                          [showClear]="true">
                        </p-select>
                      </div>
                    </div>
                    <div class="col">
                      <div class="row">
                        <div class="col-lg-12">
                          <label>Inventory Purchases:</label>
                          <div class="form-check form-switch">
                            <p-toggleswitch
                              formControlName="invPurchases"
                              [readonly]="true" />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-12">
                          <label>Warehouse IR Sent:</label>
                          <div class="form-check form-switch">
                            <p-toggleswitch
                              formControlName="invPurchaseCompleted"
                              [readonly]="true" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="d-flex pt-5 justify-content-end mb-5 hideincollapseflex gap-2"
              *ngIf="isDisabled === false">
              <p-button
                label="Cancel"
                (click)="onCancel()"
                variant="outlined"
                severity="secondary" />

              <p-button label="Save Header" (click)="insertEditedPO()" />

              <!-- <button
          type="button"
          class="btn btn-secondary me-3"
          (click)="onCancel()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="insertEditedPO()">
          Save Header
        </button> -->
            </div>
          </div>
          <div class="d-flex py-3 justify-content-end has-sticky">
            <!-- <button type="button" class="btn btn-secondary me-3" (click)="onCancel()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="addSamplePoScreen()"
      >
        Save
      </button> -->
          </div>
        </form>
        <div class="tbl-grid">
          <jni-inventory-purchase-summary-listing
            [inventoryPurchaseLines]="lines"
            [purchaseOrderHeader]="
              samplePOSummary.purchaseOrderHeader
            "></jni-inventory-purchase-summary-listing>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="samplePOSummaryDisplayModal"
  [displayModal]="samplePOSummaryDisplayModal"
  (closeEvent)="closeModalFromSamplePOSummary()"
  class="modal-header-sticky">
  <div class="panelBody">
    <jni-inventory-purchase-lines
      [purchaseOrderNumber]="samplePONumber"
      [fromStacker]="true"
      (closeEvent)="
        closeModalFromSamplePOSummary()
      "></jni-inventory-purchase-lines>
  </div>
</jni-modal-stacker>
<jni-child-po-confirmation
  [printPdfModal]="printPdfModal"
  [purchaseOrderLine]="purchaseOrderLine"
  (closePrintPdfModalEvent)="closePrinfPdfModal()">
</jni-child-po-confirmation>
